import Create from './create/CreateContract';
import Edit from './edit/EditContract';
import Individual from './individual/Contract';
import List from './list/Contracts'
import ListToExpired from './list/ContractsToExpire'

export default { Individual, Edit, Create, List, ListToExpired };
